import { getLocale } from '@/helpers/url'

export const DOMAIN = 'on-running.com'
export const CUSTOMER_SERVICE_SUBDOMAIN = `customer-service.${DOMAIN}`
export const FILTER_PAGE_PATH = 'explore'
export const FILTER_PAGE_MENS_PATH = 'explore/mens'
export const FILTER_PAGE_WOMENS_PATH = 'explore/womens'
export const SHOE_FINDER_PATH = 'shoe-finder'
export const SHIPPING_RETURNS_PATH = 'shipping_and_returns'
export const RAFFLE_FAQ_PATH = 'articles/the-cloudnova-how-do-i-get-ons-new-limited-edition-sneaker'
export const SIZE_GUIDE_PATH = 'size_guide'
export const ORDER_STATUS_PATH = 'order-status'
export const RETURNS_DIRECT_PATH = 'returns/direct'

// TODO: B2C-2485 add roger pdp url
export const PDP_ROGER_PATH = 'products/cloud/mens/black-slate'

export const getOrderStatusDirectPath = id => `${ORDER_STATUS_PATH}?id=${id}`
export const getReturnsDirectPath = id => `${RETURNS_DIRECT_PATH}?order=${id}`

export function getGraphqlEndpointUrl() {
  const hostname = window.location.origin
  const locale = getLocale(window.location.pathname)
  const localeUrl = locale ? `/${locale}` : ''
  return `${hostname}${localeUrl}/graphql`
}
